export class Department {
    id?: any;
    name?: string;
}